import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import { fetchDashboardStatsSuccess, fetchDashboardStatsFailure } from 'store/actions/dashboardActions';
import apiClient from 'clients/apiClient';
import utils from 'helpers/utils';

function* fetchDashboardStatsAsync({ payload }) {
    const { url, queries } = payload;

    try {
        const response1 = yield apiClient.read(url, queries[0]);
        const response2 = yield apiClient.read(url, queries[1]);

        const result = yield [
            ...response1,
            ...response2,
        ];

        yield put(fetchDashboardStatsSuccess(result));

        if (utils.isFunction(payload.callback)) {
            yield payload.callback();
        }
    } catch (error) {
        yield put(fetchDashboardStatsFailure(error));
    }
}

function* dashboardStatsFailedAsync({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

export default function* dashboardSagas() {
    yield [
        takeEvery('FETCH_DASHBOARD_STATS', fetchDashboardStatsAsync),
        takeEvery('FETCH_DASHBOARD_STATS_FAILURE', dashboardStatsFailedAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/dashboardSagas.js